export default "__VITE_ASSET__DY_UqeAC__"